<div class="e-flex e-align-items-center e-gap-8">
  <app-dot outageType="Unplanned" />
  <p class="e-text-sm">Strømbrudd</p>
</div>

<div class="e-flex e-align-items-center e-gap-8">
  <app-dot outageType="Planned" />
  <p class="e-text-sm">Vedlikehold</p>
</div>
